import ConditionScore from "./ConditionScore";

export default ConditionScore;